import { Hero } from '@components/hero/models/hero';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const heroComponentMock: Block<Hero> = {
  type: 'hero',
  data: {
    title: {
      text: `Créez des \\\\[[Souvenirs]]`,
      as: 'span',
    },
    cta: {
      label: `Voir toutes nos cuisines`,
      url: '/mock-nos-cuisines',
    },
    image: imageMock,
    gtmConfigCta: {
      event: 'click_cta_listing_cuisine_1',
      group: 'listing cuisine',
      description: 'cta haut de page hp',
      context: 'click premier CTA homepage',
    },
  },
};
